import { axiosInstance } from '.'

import { GET_DOCUMENT_DOWNLOAD_LINK_V1 } from './endpoints'

export const documentServices = {
  getDocumentDownloadLink: async (documentId: string) => {
    try {
      return await axiosInstance.get(GET_DOCUMENT_DOWNLOAD_LINK_V1, {
        params: { documentId },
      })
    } catch (error: any) {
      return error.response
    }
  },
}
